module.exports = __webpack_public_path__ + "static/logo-424ca114d81ea38e827d501064250508.png";